module.exports = __webpack_public_path__ + "img/flag.c3701545.png";